import { useParams, useLocation } from 'react-router-dom';
import WorkSessionForm from './WorkSessionForm';
export default function EditWorkSession() {
  const { id } = useParams();
  const location = useLocation();
  const isResume = location.pathname.includes('/resume/');
  return <WorkSessionForm mode="edit" sessionId={id} isResume={isResume}/>;
}
